import { mapState } from 'vuex'
import { localeString } from '@/config/helpers.js'

export const rfvGraphDetails = {
  props: {
    variant: {
      type: String,
      default: 'champions',
      validator: (value) => ['', 'atRisk', 'loyals', 'lowValue', 'champions', 'promising'].includes(value),
    },
    period: {
      type: Object,
      default: () => {},
    },
    data: {
      type: Object,
      default: () => {},
    },
  },

  data: () => ({}),

  computed: {
    ...mapState({ stateFilters: (state) => state.filters }),
    color() {
      const colors = {
        champions: '#D4FF00',
        loyals: '#31D472',
        promising: '#54AAFF',
        atRisk: '#FFC34E',
        lowValue: '#FF7459',
      }

      return colors[this.variant]
    },
    icon() {
      const icons = {
        champions: '🏆',
        loyals: '🎖️',
        promising: '🚀',
        atRisk: '❗',
        lowValue: '👎',
      }

      return icons[this.variant]
    },
    title() {
      const titles = {
        champions: 'Campeões',
        loyals: 'Clientes leais',
        promising: 'Promissores',
        atRisk: 'Em risco',
        lowValue: 'Baixo valor',
      }

      return titles[this.variant]
    },
    subtitle() {
      const subtitles = {
        champions: 'Seus melhores clientes, com a recência, frequência e faturamento mais alta da sua base de clientes.',
        loyals: 'Ótimos clientes, com uma boa média de recência e frequência + faturamento, abaixo apenas dos campeões.',
        promising: 'Clientes com uma boa recência, porém com a frequência + faturamento não muito alto.',
        atRisk: 'Clientes com uma boa frequência e faturamento, porém com a recência baixa.',
        lowValue: 'Clientes de baixa frequência, baixo faturamento e baixa recência.',
      }

      return subtitles[this.variant]
    },

    progress() {
      let progressItems = []

      if (this.$permissions.havePagePermission('campanhas/sms')) {
        progressItems.push({
          id: '1',
          label: 'SMS',
          value: localeString(this.data.channels.sms, 0),
          color: this.getPercentageColor(this.data.channels.sms),
        })
      }

      if (this.$permissions.havePagePermission('campanhas/email-v2') && this.$getAllowedModules()['email_v2']) {
        progressItems.push({
          id: '2',
          label: 'E-mail',
          value: localeString(this.data.channels.email, 0),
          color: this.getPercentageColor(this.data.channels.email),
        })
      }

      if (this.$permissions.havePagePermission('campanhas/whatsapp') && this.$getAllowedModules()['whatsapp']) {
        progressItems.push({
          id: '3',
          label: 'Whatsapp',
          value: localeString(this.data.channels.whatsapp, 0),
          color: this.getPercentageColor(this.data.channels.whatsapp),
        })
      }

      if (this.$permissions.havePagePermission('campanhas/aplicativo') && this.$getAllowedModules()['push']) {
        progressItems.push({
          id: '4',
          label: 'Aplicativo',
          value: localeString(this.data.channels.app, 0),
          color: this.getPercentageColor(this.data.channels.app),
        })
      }

      return progressItems
    },
  },

  methods: {
    getPercentageColor(percentage) {
      if (percentage <= 20) return '#E03210'
      else if (percentage > 20 && percentage <= 40) return '#F36600'
      else if (percentage > 40 && percentage <= 60) return '#F3AF00'
      else if (percentage > 60 && percentage <= 80) return '#0FC94D'
      else return '#0A8533'
    },
  },
}
